import { Button } from '@apollo/orbit';
import React, { useEffect } from 'react';

import { useSchema } from 'src/app/graph/hooks/useSchema';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { useTrackCustomEvent } from 'src/hooks/useTrackCustomEvent';

export const RefetchSchemaButton = () => {
  const { refreshSchema } = useSchema();

  const [shouldShowRefetchSuccess, setShouldShowRefetchSuccess] =
    React.useState(false);

  const trackCustomEvent = useTrackCustomEvent();

  useEffect(() => {
    if (shouldShowRefetchSuccess) {
      const timeout = setTimeout(() => {
        setShouldShowRefetchSuccess(false);
      }, 1000);
      return () => clearTimeout(timeout);
    }
  }, [shouldShowRefetchSuccess]);

  return (
    <Tooltip
      label={
        shouldShowRefetchSuccess
          ? 'Schema fetched'
          : 'Click here to fetch the schema manually from your current sandbox endpoint'
      }
      placement="bottom"
    >
      <Button
        aria-label="Fetch the schema manually for current Sandbox endpoint"
        variant="primary"
        onClick={() => {
          setShouldShowRefetchSuccess(true);
          trackCustomEvent({
            action: 'manual_refetched_schema',
            category: 'Sandbox',
          });
          refreshSchema?.();
        }}
        size="sm"
      >
        Refetch Schema
      </Button>
    </Tooltip>
  );
};
